module.exports = __webpack_public_path__ + "static/media/saibdirect-logo.c2870918.png";